import { get } from 'svelte/store';
import { loginSessionStore } from '../login/loginSessionStore';

export const getSubmittedVotesKey = (pollId: string) => {
  return `${pollId}-${get(loginSessionStore)?.user?.sub}-submitted-votes`;
};

export const getStoredVotesKey = (pollId: string) => {
  return `${pollId}-${get(loginSessionStore)?.user?.sub}-stored-votes`;
};
